import Right from './Right';

export default Right;
